import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { WorksheetEntitySummaryIndex } from 'services/worksheet/types';
import { getSprayEventApplicationTypeDisplay } from 'services/sprayEvents/utils';
import { selectSprayWorksheetEntitySummaries } from '../../../../selectors';
import { Props } from './index';

const selectEntitySummaryIndex = (
    state: AppState,
    props: Props
): WorksheetEntitySummaryIndex => props.entitySummaryIndex;

const selectApplicationType = createDeepEqualSelector(
    selectSprayWorksheetEntitySummaries,
    selectEntitySummaryIndex,
    (entitySummaries, index) => {
        const applicationType: string = get(entitySummaries, [
            index,
            'applicationType'
        ]);

        return getSprayEventApplicationTypeDisplay(applicationType);
    }
);

const makeSelectApplicationType = (): typeof selectApplicationType =>
    selectApplicationType;

export { selectEntitySummaryIndex, makeSelectApplicationType };
